import React, { useEffect, useRef } from "react";
import { Grid, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import PendingIcon from "@mui/icons-material/Pending";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Card from "@mui/material/Card";
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { getBookingOverview} from "../actions/GenomicsSampleAccessioningActions";
import BarChartTwoToneIcon from "@mui/icons-material/BarChartTwoTone";
import Avatar from "@mui/material/Avatar";
import moment from "moment";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      height: "100%",
      padding: "20px",
    },
    cardContent: {
      textAlign: "center",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: { color: "black" },
  })
);

interface Props {
  getBookingOverview: any;
  bookingoverview: any;
  
}

const Dashboard: React.FC<Props> = ({
  getBookingOverview,
  bookingoverview,
 
}) => {
  const classes = useStyles();
  const timer = useRef<any>(0);

  useEffect(() => {
    getBookingOverview("");
  }, []);

  const isEmpty = Object.keys(bookingoverview).length === 0;

  return (
    <div style={{ width: "90%", margin: "60px auto" }}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <h3>Dashboard</h3>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          <TextField
            type="date"
            defaultValue={moment().format("YYYY-MM-DD")}
            aria-readonly
            onChange={(e) => {
              getBookingOverview(
                `booking_date=${moment(e.target.value).format("YYYY-MM-DD")}`
              );
            }}
            inputProps={{ max: moment().format("YYYY-MM-DD") }}
          />
        </Grid>
      </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div style={{ display: "flex", width: "100%" }}>
              <h6>Batches</h6>

              <hr style={{ width: "100%", marginTop: 10 }} />
            </div>
          </Grid>
          <Grid item xs={12} lg={3} sm={6}>
            <Card className={classes.card}>
              <Grid container>
                <Grid item sm={3}>
                  <Avatar
                    sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                    aria-label="recipe"
                  >
                    <BarChartTwoToneIcon style={{ color: "#fa4d83" }} />
                  </Avatar>
                </Grid>
                <Grid item sm={9}>
                  <h5>{isEmpty ? 0 : bookingoverview?.total_booking}</h5>
                  <span style={{ color: "grey" }}>Total</span>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} lg={3} sm={6}>
            <Card className={classes.card}>
              <Grid container>
                <Grid item sm={3}>
                  <Avatar
                    sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                    aria-label="recipe"
                  >
                    <CallReceivedIcon style={{ color: "#fa4d83" }} />
                  </Avatar>
                </Grid>
                <Grid item sm={9}>
                  <h5>{isEmpty ? 0 : bookingoverview?.total_acknowledged}</h5>
                  <span style={{ color: "grey" }}>Lab Received</span>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} lg={3} sm={6}>
            <Card className={classes.card}>
              <Grid container>
                <Grid item sm={3}>
                  <Avatar
                    sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                    aria-label="recipe"
                  >
                    <PendingIcon style={{ color: "#fa4d83" }} />
                  </Avatar>
                </Grid>
                <Grid item sm={9}>
                  <h5>{isEmpty ? 0 : bookingoverview?.total_pending_booking}</h5>
                  <span style={{ color: "grey" }}>Pending</span>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} lg={3} sm={6}>
            <Card className={classes.card}>
              <Grid container>
                <Grid item sm={3}>
                  <Avatar
                    sx={{ bgcolor: "#ffeff5", marginTop: "8px" }}
                    aria-label="recipe"
                  >
                    <ApartmentIcon style={{ color: "#fa4d83" }} />
                  </Avatar>
                </Grid>
                <Grid item sm={9}>
                  <h5>{isEmpty ? 0 : bookingoverview?.total_consolidate}</h5>
                  <span style={{ color: "grey" }}>Report Done</span>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
     
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  bookingoverview: state.GenomicsSaReducer.bookingoverview,
});

export default connect(mapStateToProps, {
  getBookingOverview,
})(Dashboard);